import {GET_PLAYERS} from '../constants';

const initialState = {
	data: [],
};

const players = (state = initialState, action) => {
	switch (action.type) {
		case GET_PLAYERS:
			return {...state, data: [...action.players]};
		default:
			return state;
	}
};

export default players;
